<template>
  <!--style="width: 100%;position: relative;overflow: hidden;text-align: center;border: 1px solid #f1f2f3;"-->
  <div>
    <el-button size='mini' @click="toBigChange" icon="el-icon-zoom-in"
               style="position: absolute;top: 2px ;left: 2px;z-index: 999;"></el-button>
    <el-button size='mini' @click="toSmallChange" icon="el-icon-zoom-out"
               style="position: absolute;top: 2px ;left: 40px;z-index: 999;"></el-button>
    <img id="img" :src="src" alt="" @mousedown.prevent="dropImage" :style="{transform:'scale('+multiples+')'}">
  </div>
</template>
<script>
export default {
  name: "imageRead",
  props: ['src'],
  data() {
    return {
      multiples: 1,
      odiv: null,
    }
  },
  mounted() {
    this.dropImage(null)
  },
  watch: {
    src(newValue, oldValue) {
      this.multiples = 1
      if (this.odiv !== null) {
        this.odiv.style.left = '0px';
        this.odiv.style.top = '0px';
      }
    },
  },
  methods: {
    toBigChange() {
      if (this.multiples >= 2) {
        return;
      }
      this.multiples += 0.2;
    },
    // 缩小
    toSmallChange() {
      if (this.multiples <= 0.8) {
        return;
      }
      this.multiples -= 0.2;
    },
    // 拖拽
    dropImage(e) {
      if (e === null) {
        return
      }
      this.odiv = e.target;        //获取目标元素
      //算出鼠标相对元素的位置
      let disX = e.clientX - this.odiv.offsetLeft;
      let disY = e.clientY - this.odiv.offsetTop;
      document.onmousemove = (e) => {       //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //绑定元素位置到positionX和positionY上面
        this.positionX = top;
        this.positionY = left;

        //移动当前元素
        this.odiv.style.left = left + 'px';
        this.odiv.style.top = top + 'px';
      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
  }
}
</script>
<style scoped>
img {
  width: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/view/readpage/imageread.vue